/* Foamly storefront behaviour: gallery, bundle picker with per-camera colours (+ add-on items), direct-to-checkout buy, sticky bar, sliders, drawer, delivery date, tracking. */
(function () {
  'use strict';
  if (window.__foamlyInit) return; window.__foamlyInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = document.documentElement.lang || 'en';
  var mfEl = document.querySelector('[data-fm-money-format]');
  var moneyFormat = (mfEl && mfEl.getAttribute('data-fm-money-format')) || '${{amount}}';
  function fmtNum(cents, decimals, thousands, dec) {
    var n = (cents / 100).toFixed(decimals);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + dec + parts[1] : parts[0];
  }
  function money(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }
  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* ---------- mobile drawer ---------- */
  qsa('[data-fm-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { var d = qs('#fm-drawer'); if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }); });
  qsa('[data-fm-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { var d = qs('#fm-drawer'); if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; } }); });

  /* ---------- delivery estimate ---------- */
  qsa('[data-fm-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min') || '8', 10), max = parseInt(el.getAttribute('data-max') || '14', 10);
    function add(d) { var x = new Date(); var n = 0; while (n < d) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n++; } return x; }
    var fmt = { day: 'numeric', month: 'long' };
    var a = add(min).toLocaleDateString(locale, fmt), b = add(max).toLocaleDateString(locale, fmt);
    var t = el.querySelector('[data-fm-delivery-dates]'); if (t) t.textContent = a + ' – ' + b;
  });

  /* ---------- generic slider (gallery + moments) ---------- */
  function initSlider(wrap) {
    var track = qs('[data-fm-slides]', wrap); if (!track) return;
    var slides = qsa('[data-fm-slide]', track);
    var thumbs = qsa('[data-fm-thumb]', wrap);
    var dots = qsa('[data-fm-dot]', wrap);
    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var at = thumbs[i]; if (at && at.parentElement) { at.parentElement.scrollTo({ left: at.offsetLeft - at.parentElement.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' }); }
    }
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    dots.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    var prev = qs('[data-fm-prev]', wrap), next = qs('[data-fm-next]', wrap);
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { var c = current(); goTo(c >= slides.length - 1 ? 0 : c + 1); });
    wrap.fmGoToMedia = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    };
    mark();
  }
  qsa('[data-fm-slider]').forEach(initSlider);

  /* ---------- product ---------- */
  function readAddon(b) {
    var id = b && b.getAttribute('data-addon-id');
    if (!id) return null;
    return { id: parseInt(id, 10), price: parseInt(b.getAttribute('data-addon-price'), 10) || 0, compare: parseInt(b.getAttribute('data-addon-compare'), 10) || 0 };
  }
  function initProduct(sec) {
    var dataEl = qs('script[data-fm-product-json]', sec); if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;
    function variantById(id) { return product.variants.find(function (x) { return x.id === id; }); }
    var initialId = parseInt(sec.getAttribute('data-initial-variant'), 10);
    var bundles = qsa('[data-fm-bundle]', sec);
    var active = qs('[data-fm-bundle].is-active', sec) || bundles[0] || null;
    var state = { variant: variantById(initialId) || product.variants.find(function (v) { return v.available; }) || product.variants[0], bundleEl: active };
    bundles.forEach(function (b) {
      var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
      b.__slots = []; for (var i = 0; i < q; i++) b.__slots.push(state.variant.id);
    });
    var gallery = qs('[data-fm-slider]', sec);
    var discount = parseFloat(sec.getAttribute('data-bundle-discount') || '0') || 0;

    function qtyOf(b) { return b ? (parseInt(b.getAttribute('data-qty'), 10) || 1) : 1; }
    function bundlePrice(b) {
      var qty = qtyOf(b), addon = readAddon(b), v = state.variant;
      var base = v.price * qty;
      var price = qty > 1 ? Math.round(base * (1 - discount / 100)) : base;
      var unitCmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
      var compare = unitCmp * qty;
      if (addon) { price += addon.price; compare += addon.compare; }
      return { price: price, compare: compare };
    }
    function showVariant(v) {
      state.variant = v;
      if (v.featured_media && gallery && gallery.fmGoToMedia) gallery.fmGoToMedia(v.featured_media.id);
    }
    function selectedLines() {
      var b = state.bundleEl, counts = {}, order = [];
      var ids = b && b.__slots ? b.__slots : [state.variant.id];
      ids.forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      var addon = readAddon(b); if (addon) items.push({ id: addon.id, quantity: 1 });
      return items;
    }
    function allAvailable() {
      var b = state.bundleEl; var ids = b && b.__slots ? b.__slots : [state.variant.id];
      return ids.every(function (id) { var v = variantById(id); return v && v.available; });
    }
    function render() {
      var v = state.variant;
      qsa('[data-fm-swatch]', sec).forEach(function (b) { var on = parseInt(b.getAttribute('data-variant-id'), 10) === v.id; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      qsa('[data-fm-variant-name]', document).forEach(function (el) { el.textContent = v.option1 || v.title; });
      bundles.forEach(function (b) {
        var p = bundlePrice(b); var on = b === state.bundleEl;
        b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        var pe = qs('[data-fm-bundle-price]', b); if (pe) pe.textContent = money(p.price);
        var ce = qs('[data-fm-bundle-compare]', b); if (ce) ce.textContent = p.compare > p.price ? money(p.compare) : '';
        var se = qs('[data-fm-bundle-save]', b); if (se) se.textContent = p.compare > p.price ? (se.getAttribute('data-label') || 'Save') + ' ' + money(p.compare - p.price) : '';
        qsa('[data-fm-slot]', b).forEach(function (slot) {
          var idx = parseInt(slot.getAttribute('data-fm-slot'), 10); var sel = b.__slots[idx];
          qsa('[data-fm-slot-opt]', slot).forEach(function (o) { o.classList.toggle('is-active', parseInt(o.getAttribute('data-variant-id'), 10) === sel); });
          var sv = variantById(sel); var nm = qs('[data-fm-slot-name]', slot); if (nm && sv) nm.textContent = sv.option1 || sv.title;
        });
      });
      var cur = bundlePrice(state.bundleEl);
      qsa('[data-fm-price]', document).forEach(function (el) { el.textContent = money(cur.price); });
      qsa('[data-fm-compare]', document).forEach(function (el) { el.textContent = cur.compare > cur.price ? money(cur.compare) : ''; });
      var ok = allAvailable();
      qsa('[data-fm-buy]', document).forEach(function (btn) {
        if (btn.tagName === 'BUTTON') btn.disabled = !ok;
        var l = qs('[data-fm-buy-label]', btn);
        if (l) l.textContent = ok ? (btn.getAttribute('data-label') || 'Buy now') : (btn.getAttribute('data-soldout') || 'Sold out');
      });
      var img = qs('[data-fm-sticky-img]'); if (img && v.featured_image) { img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
      var input = qs('input[name="id"]', sec); if (input) input.value = v.id;
      var qin = qs('input[name="quantity"]', sec); if (qin) qin.value = qtyOf(state.bundleEl);
      if (window.history && window.history.replaceState && sec.getAttribute('data-update-url') === 'true') {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }
    /* optional colour row above bundles: sets every camera slot */
    qsa('[data-fm-swatch]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variantById(parseInt(b.getAttribute('data-variant-id'), 10)); if (!v) return;
        bundles.forEach(function (bb) { bb.__slots = bb.__slots.map(function () { return v.id; }); });
        showVariant(v); render();
      });
    });
    bundles.forEach(function (b) {
      function activate() { if (state.bundleEl !== b) { state.bundleEl = b; var v = variantById(b.__slots[0]); if (v) showVariant(v); render(); } }
      b.addEventListener('click', function (e) { if (e.target.closest('[data-fm-slot-opt]')) return; activate(); });
      b.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === b) { e.preventDefault(); activate(); } });
      qsa('[data-fm-slot-opt]', b).forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var slot = o.closest('[data-fm-slot]'); var idx = parseInt(slot.getAttribute('data-fm-slot'), 10);
          var v = variantById(parseInt(o.getAttribute('data-variant-id'), 10)); if (!v) return;
          b.__slots[idx] = v.id; state.bundleEl = b; showVariant(v); render();
        });
      });
    });

    function buy(btn) {
      if (!allAvailable()) return;
      btn.classList.add('is-loading'); if (btn.tagName === 'BUTTON') btn.disabled = true;
      var items = selectedLines();
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = root + 'checkout'; })
        .catch(function () {
          window.location.href = root + 'cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
        });
    }
    qsa('[data-fm-buy]', document).forEach(function (btn) {
      if (btn.__fmBound) return; btn.__fmBound = true;
      btn.addEventListener('click', function (e) { e.preventDefault(); buy(btn); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { qsa('[data-fm-buy]').forEach(function (b) { b.classList.remove('is-loading'); }); render(); } });

    /* sticky bar: visible once the main buy button has scrolled above the viewport */
    var sticky = qs('[data-fm-sticky]');
    var mainBtn = qs('[data-fm-buy-main]', sec);
    if (sticky && mainBtn) {
      var ticking = false;
      var upd = function () { ticking = false; sticky.classList.toggle('is-visible', mainBtn.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    render();
  }
  qsa('[data-fm-product]').forEach(initProduct);

  /* ---------- order tracking (17TRACK widget) ---------- */
  var tf = qs('#fm-track-form');
  if (tf) {
    tf.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = (qs('#fm-track-num').value || '').trim().replace(/\s+/g, '');
      var out = qs('#fm-track-result');
      var ext = 'https://t.17track.net/en#nums=' + encodeURIComponent(num);
      if (!num) { out.innerHTML = '<div class="fm-alert fm-alert--err">' + (tf.getAttribute('data-empty') || 'Please enter your tracking number.') + '</div>'; return; }
      out.innerHTML = '<div id="fm-yq"></div><p class="fm-note"><a target="_blank" rel="noopener" href="' + ext + '">' + (tf.getAttribute('data-ext') || 'Open on 17TRACK') + '</a></p>';
      function show() { try { window.YQV5.trackSingle({ YQ_ContainerId: 'fm-yq', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num }); } catch (err) { window.open(ext, '_blank'); } }
      if (window.YQV5) { show(); return; }
      var s = document.createElement('script'); s.src = 'https://www.17track.net/externalcall.js'; s.onload = show; s.onerror = function () { window.open(ext, '_blank'); }; document.body.appendChild(s);
    });
  }
})();
